class WIcartDrawer extends HTMLElement {
	constructor() {

		super();
		this.addEventListener('click', this.closeCart.bind(this));
		this.addEventListener('click', this.incQuantity.bind(this));
		this.addEventListener('click', this.decQuantity.bind(this));
		this.addEventListener('click', this.revQuantity.bind(this));
		this.addEventListener('click', this.cartBgclick.bind(this));
		
	}
	connectedCallback() {
		this.clickOncart();
		this.quickAddUpdate();
		// this.checkOutFormSubmit();
		// this.defaultATC();
		// this.totalSaving();
		this.freeShipping();
		this.giftBagAdd();
		this.discountPopUp();
		// this.removeCertainProductTypes();
	}

	clickOncart() {
		document.querySelector('.cart-link').addEventListener('click', (e) => {
			e.preventDefault();
			this.openCart();
		});
		document.addEventListener('opencart', () => {
			this.openCart();
			let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
			let emptyCart = document.querySelector('.WI_cartDrawerin_cart_empty');
			if (loadingCartBlock != null) {
				loadingCartBlock.style.display = "block";
			}
			if (emptyCart != null) {
				emptyCart.style.display = "none";
			}
		})
	}
	openCart() {
		let cartDrawer = this.querySelector('.WI_cartDrawerin');
		let cartDrawerUpsell = this.querySelector('.WI_cartDrawerin_upsell');
		this.style.display = "flex";
		setTimeout(() => {
			this.style.backgroundColor = 'rgba(255,255,255,0.5)';
			cartDrawer.style.transform = 'translateX(0)';
			setTimeout(() => {
				cartDrawerUpsell.classList.add('WI_cartDrawerin_upsell_active');
			}, 200);
		}, 10);
	}
	closeCart(event) {
		if (event.target.closest('.WI_cartDrawerCls')) {
			document.dispatchEvent(new CustomEvent('closeCart', {bubbles: true}));
			let cartDrawer = this.querySelector('.WI_cartDrawerin');
			let cartDrawerUpsell = this.querySelector('.WI_cartDrawerin_upsell');
			cartDrawerUpsell.classList.remove('WI_cartDrawerin_upsell_active');
			setTimeout(() => {
				this.style.backgroundColor = 'rgba(0,0,0,0)';
				cartDrawer.style.transform = 'translateX(100%)';
				setTimeout(() => {
					this.style.display = "none";
				}, 310);
			}, 10);
		}
	}
	cartBgclick(event) {
		if (event.target.matches('wi-cartdrawer')) {
			let cartDrawer = this.querySelector('.WI_cartDrawerin');
			let cartDrawerUpsell = this.querySelector('.WI_cartDrawerin_upsell');
			cartDrawerUpsell.classList.remove('WI_cartDrawerin_upsell_active');
			setTimeout(() => {
				this.style.backgroundColor = 'rgba(0,0,0,0)';
				cartDrawer.style.transform = 'translateX(100%)';
				setTimeout(() => {
					this.style.display = "none";
				}, 310);
			}, 10);
		}
	}
	async updateCart() {

		let res = await fetch('/?section_id=wi-cartdrawer');
		let text = await res.text();
		let html = document.createElement('div');
		html.innerHTML = text;
		let cartItems = html.querySelector('.WI_cartDrawerin_cart').innerHTML;
		document.querySelector('.WI_cartDrawerin_cart').innerHTML = cartItems;
		let cartPriceInfo = html.querySelector('.WI_cartDrawerin_cart')?.querySelectorAll('[data-giftwrap]');
		let cartCount = Number(html.querySelector('.WI_cartDrawerin_cart')?.getAttribute('data-cartcount'));
		// this.checkOutFormSubmit()
		// this.totalSaving();
		this.freeShipping();
		this.giftBagAdd();
		this.discountPopUp();
		this.checkEMptyCart(cartPriceInfo,cartCount);
		await this.addJewlBox();
		await this.addFreeProduct();
	}
	quickAddUpdate() {
		document.addEventListener('updateCart', async (e) => {
			await this.updateCart();
		});
	}
	async incQuantity(event) {
		if (event.target.closest('.WI_cartDrawer_plus')) {
			let rOOt = event.target;
			let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
			let quantity = Number(rOOt.parentElement.parentElement.querySelector('input').value);
			let newQuantity = quantity + 1;
			rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');
			await fetch('/cart/update.js', {
				method: 'post',
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					updates: {
						[keyID]: newQuantity
					}
				})
			});
			await this.updateCart();
		}
	}
	async decQuantity(event) {
		if (event.target.closest('.WI_cartDrawer_minus')) {
			let rOOt = event.target;
			let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
			let quantity = Number(rOOt.parentElement.parentElement.querySelector('input').value);
			let newQuantity = quantity - 1;
			rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');

			await fetch('/cart/update.js', {
				method: 'post',
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					updates: {
						[keyID]: newQuantity
					}
				})
			});
			this.updateCart();
		}
	}
	async revQuantity(event) {
		if (event.target.closest('.cartDrawerRemove')) {
			let rOOt = event.target;
			let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
			let quantity = 0;
			console.log(keyID);
			rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');
			await fetch('/cart/update.js', {
				method: 'post',
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					updates: {
						[keyID]: quantity
					}
				})
			});
				await this.updateCart();
		}
	}
	async freeShipping() {
        let countries = [
            { price: 400, countries: ['Denmark'] },
            { price: 1490, countries: ['Norway'] },
            { price: 520, countries: ['Sweden'] }
        ];
        let countryName = this.querySelector('.WI_cartCountry').value;
        console.log(countryName);
        let freeShippingValue;
        for (let group of countries) {
            if (group.countries.includes(countryName)) {
                freeShippingValue = Number(group.price);
            }
        }
        console.log(freeShippingValue);
        // let freeShippingValue = Number(this.querySelector('.freeShippingValue').value);
        let freeShippingPara = this.querySelector('#freeShippingTxt');
        let freeShippingProgressBar = this.querySelector('.WI_freeShippingBar_progress');
        let shippingRes = await fetch('/cart.js');
        let shippingData = await shippingRes.json();
        let cartPrice = Math.round(shippingData.total_price / 100);
        if (cartPrice < freeShippingValue) {
            let shippingPriceDiffer = freeShippingValue - cartPrice;
            freeShippingPara.innerHTML = "Du er kun <strong style='color:rgba(0,0,0,1);'>"  + shippingPriceDiffer + "kr." +"</strong> fra at få gratis fragt!";
            let shippingPercent = parseInt(cartPrice / freeShippingValue * 100);
            freeShippingProgressBar.style.width = shippingPercent + "%";
        } else {
            freeShippingPara.innerHTML = "Tillykke! Du har opnået gratis fragt på din ordre!"
            freeShippingProgressBar.style.width = '100%';
        }
    }
	
	async totalSaving() {
		let lineItem = document.querySelectorAll('.WI_cartDrawer_item');
		let totalSaving = 0;
		lineItem.forEach(item => {
			let totalSavingData = item.getAttribute('data-savingPrice');
			totalSaving += Number(totalSavingData);
		});
		setTimeout(() => {
			console.log(totalSaving / 100);
			if (totalSaving > 0) {
				document.querySelector('.savingIndiactor').style.display = 'flex';
				document.querySelector('.savedMoney').innerHTML = "-" + (totalSaving / 100).toLocaleString('da-DK', {
					style: 'currency',
					currency: 'DKK'
				});
			}
		}, 100);
	}
	defaultATC() {
		const allForm = document.querySelectorAll('form[action="/cart/add"]');
		allForm.forEach(elem => {
			elem.addEventListener('submit', async (e) => {
				e.preventDefault();
				let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
				let emptyCart = document.querySelector('.WI_cartDrawerin_cart_empty');
				if (loadingCartBlock != null) {
					loadingCartBlock.style.display = "block";
				}
				if (emptyCart != null) {
					emptyCart.style.display = "none";
				}
				this.openCart();
				console.log("ghdgdgdgdgdgdgdgdg");
				await this.updateCart();
			})
		});
	}

	// When there is cart form submition
	async checkOutFormSubmit() {
		let cartForm = this.querySelector('form[action="/cart"]');
		let shopUrl = this.querySelector('.WI_cartShopUrl')?.value;
		let cartFormBtn = this.querySelector('.WI_cartDrawer_checkout');
		cartForm?.addEventListener('submit', async (e) => {
			e.preventDefault();
			let lOader = document.createElement('div'); // Create the div element
				lOader.classList.add('loader'); // Add the 'loader' class to it
				cartFormBtn.appendChild(lOader);
			let boxId = this.querySelector('[data-boxId]')?.getAttribute('data-boxId');
			let boxQuantity = Number(this.querySelector('[data-boxQuantity]')?.getAttribute('data-boxQuantity'));
			let cartTotalPrice = Number(this.querySelector('.WI_cartTotalPrice').value);
			let freeCartPrice = Number(this.querySelector('.WI_freeProductPrice').value);
			let freeProduct = this.querySelector('.WI_freeProduct').value;
			let formData = {
				items: []
			}; // Initialize formData with an empty items array

			if (cartTotalPrice >= freeCartPrice) {
				// If the cart total is enough for a free product
				if (boxId && boxQuantity) {
					// Both boxId and boxQuantity are present
					formData.items.push({
						id: boxId,
						quantity: boxQuantity
					}, {
						id: freeProduct,
						quantity: 1
					});
				} else {
					formData.items.push({
						id: freeProduct,
						quantity: 1
					}); // Add free product
				}
			} else if (boxId && boxQuantity) {
				// Only boxId and boxQuantity are present, and total is not enough for a free product
				formData.items.push({
					id: boxId,
					quantity: boxQuantity
				});
			}
			console.log(formData);

			if (formData.items) {
				try {
					let responce = await fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(formData)
					});
					localStorage.setItem('checkout', "true");
					window.location.href = shopUrl + '/checkout';
				} catch (error) {
					console.log("ERROE" + error);
				}
			}
		})
	}

	// cart gift bag adding function
	giftBagAdd() {
		let giftPopOpen = false;
		let giftPop = this.querySelector('.WI_cartGift_giftPop');
		this.querySelector('.WI_cartGift_gift')?.addEventListener('click', ()=>{
			if (giftPopOpen == false) {
				giftPop.style.display = "block";
				giftPop.style.bottom = "50px";
				setTimeout(() => {
					giftPop.style.opacity = "1";
				}, 10);
				giftPopOpen = true;
			}else{
				giftPop.style.opacity = "0";
                setTimeout(() => {
					giftPop.style.bottom = "0px";
					giftPop.style.display = "none";
                }, 220);
                giftPopOpen = false;
			}
		});
		this.querySelectorAll('[data-varaiantid]').forEach(giftBagATC=>{
			giftBagATC.addEventListener('click', async ()=>{
				let variantID = giftBagATC.getAttribute('data-varaiantid');
				let lOader = document.createElement('div'); // Create the div element
				lOader.classList.add('loader'); // Add the 'loader' class to it
				giftBagATC.appendChild(lOader);
				try {
					let responce = await fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ items: [{ id: variantID, quantity: 1 }] })
					});
					this.updateCart();
				} catch (error) {
					console.log("Gift bag add error: "+ error);
					
				}
			});
		});
	}

	// Discount pop up
	discountPopUp() {
		let discountPop = this.querySelector('.WI_discountPop_mian');
		let discountPopOpen = false;
		document.addEventListener('closeCart', ()=>{
			discountPop.style.opacity = "0";
			
				discountPop.style.bottom = "0px";
				discountPop.style.display = "none";
			discountPopOpen = false;
		});
		this.querySelector('.WI_cartGift_discount')?.addEventListener('click', ()=>{
			if (discountPopOpen == false) {
				discountPop.style.display = "flex";
				discountPop.style.bottom = "195px";
                setTimeout(() => {
                    discountPop.style.opacity = "1";
                }, 10);
                discountPopOpen = true;
            }else{
                discountPop.style.opacity = "0";
                setTimeout(() => {
					discountPop.style.bottom = "0px";
                    discountPop.style.display = "none";
                }, 220);
                discountPopOpen = false;
            }
		});
		
	}
        
	// Ensure the removal of specific product types to prevent duplication when customers come back from the checkout page."
	async removeCertainProductTypes(){
		let sessionStorage = localStorage.getItem('checkout');
		let removeForm = [];
		if (sessionStorage == 'true') {
			try {
				let responce = await fetch(window.Shopify.routes.root + 'cart.js');
				let cartData = await responce.json();
				cartData.items.forEach(cart => {
					if (cart.product_type == "Jewel Box - Small") {
						removeForm.push({id: cart.key, quantity: 0});
					}
					if (cart.product_type == "Jewel Box - Large") {
						removeForm.push({id: cart.key, quantity: 0});
					}
					if (cart.product_type == "free") {
						removeForm.push({id: cart.key, quantity: 0});
					}
				});
				console.log(removeForm);
				await removeProduct();
				localStorage.setItem('checkout', "false");
			} catch (error) {
				console.log('Certain Product Types removal Error: '+ error);
			}	
		}
		async function removeProduct() {
			removeForm.forEach(async (item) => {
				try {
					let removeResponce = await fetch(window.Shopify.routes.root + 'cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({id: item.id, quantity: item.quantity})
					});
					console.log(removeResponce);
				} catch (error) {
					console.log('Certain Product Types removing Error:'+ error);
				}
			});
		}
	}

	// Adding free product but it will not perform update cart functionality
	async addFreeProduct() {
		let freeProductPrice = Number(this.querySelector('.WI_freeProductPrice').value) * 100;
		let freeProduct = this.querySelector('.WI_freeProduct').value;
		let haveFreeProduct = false;
		let freeProductKey = "";
		try {
			let responce  = await fetch(window.Shopify.routes.root + 'cart.js');
			let cartData = await responce.json();
			//^^ checking if price is greater or equle to free product price
			if (cartData.total_price >= freeProductPrice) {
				//^^ checking if free product is already there
				for (let item of cartData.items) {
					if (item.product_type === 'free') {
						haveFreeProduct = true;
						break;  // Exit the loop once a free product is found
					}
				}
				//^^ checking is there is no free product then will add free product and this condition is outside the forloop so it dont run at every iteration
				console.log(haveFreeProduct);
				
				if (haveFreeProduct == false) {
					let formData = {'items':[{'id': freeProduct, 'quantity': 1}]};
					let addResponce = await fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(formData)
					});
				}
			}
			//^^ Adding else statment for if cart price is less then free product price then it will the the free product it its already there 
			else{
				console.log("nononno");
				
				cartData.items.forEach(item => {
					if(item.product_type == 'free'){
                        haveFreeProduct = true;
						freeProductKey = item.key;
						console.log(freeProductKey);
						
                    }
				});
				if (haveFreeProduct == true) {
					let formData = {'id': freeProductKey, 'quantity': 0};
					let updateResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify( formData )
					});
					console.log(updateResponse);
				}
			}
			
		} catch (error) {
			console.log("free product function", error);
		}
	}

	// Adding jewl box
	async addJewlBox() {
		
		let charmBox = this.querySelector('.WI_charmBoxId').value;
		let chainBox = this.querySelector('.WI_chainBoxId').value;
		 let charmQuan = 0;
		 let chainQuan = 0;
		 let smallBox = 0;
		 let smallBoxKey = "";
		 let largeBoxKey = "";
		 let largeBox = 0;
		let jewlArray = [];
		//^^ Getting cart data 
		try {
			let jewlResponce = await fetch(window.Shopify.routes.root + 'cart.js');
			let jewlData = await jewlResponce.json();
			//^^ Checking if there are any Charm or Chain in the cart data
			jewlData.items.forEach(item => {
				//^^ If there is a charm add there quantity and put it in charmQuan variable
				if (item.product_type == "Charms") {
                    charmQuan += item.quantity;
                }
				//^^ If there is a chain add there quantity and put it in chainQuan variable
				if (item.product_type == "Chains") {
					chainQuan += item.quantity;
				}
				//^^ If there is a chain add there quantity and put it in chainQuan variable
				if (item.product_type == "Jewel Box - Small") {
					smallBox += item.quantity;
					smallBoxKey = item.key;
				}
				//^^ If there is a chain add there quantity and put it in chainQuan variable
				if (item.product_type == "Jewel Box - Large") {
					largeBox += item.quantity;
					largeBoxKey = item.key;
				}
			});
			//^^ Checking if there is any Charm or Chain and if it is greater then 0
			if (chainQuan > 0) {
				if (smallBox > 0) {
					this.checkLoader(true);
					let smallBoxRes = await fetch(window.Shopify.routes.root + 'cart/change.js', {
						method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({id: smallBoxKey, quantity: 0})
					});
					this.checkLoader(false);
				}
				if (largeBox > 0) {
					this.checkLoader(true);
					let largeBoxRes = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({id: largeBoxKey, quantity: chainQuan})
                    });
					this.checkLoader(false);
				}else if(largeBox <= 0){
					console.log('addJewlBox');
					this.checkLoader(true);
                    let largeBoxRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({id: chainBox, quantity: chainQuan})
                    });
					this.checkLoader(false);
				}
			}else if(charmQuan > 0){
				if (largeBox > 0) {
					this.checkLoader(true);
					let smallBoxRes = await fetch(window.Shopify.routes.root + 'cart/change.js', {
						method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({id: largeBoxKey, quantity: 0})
					});
					this.checkLoader(false);
				}
				console.log("charm run");
				if (smallBox > 0) {
					this.checkLoader(true);
					let smallBoxRes = await fetch(window.Shopify.routes.root + 'cart/change.js', {
						method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({'id': smallBoxKey, 'quantity': charmQuan})
					});
					this.checkLoader(false);
				}else if(smallBox <= 0){
					console.log('addJewlBox');
					this.checkLoader(true);
					let smallBoxRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({id: charmBox, quantity: charmQuan})
					});
					this.checkLoader(false);
				}
			}
		} catch (error) {
			console.log('Jwel box error', error);
			
		}
		
	}

	checkLoader(show) {
		let cartFormBtn = this.querySelector('.WI_cartDrawer_checkout');
		let lOader = this.querySelector('.loaderCon');
				if (show == true) {
					lOader.style.display = 'flex';	
				}else{
					lOader.style.display = 'none';
				}
	}

	// Check for empty cart
	async checkEMptyCart(price,cartcount) {

		document.dispatchEvent(new CustomEvent('closeCart', {bubbles: true}));
		if (cartcount == 0) {
			console.log(cartcount+"cartlevel");
			await fetch("/discount/CLEAR");
			localStorage.removeItem("discountCode");
			document.querySelector("#applied-discount-code .applied-discount-code-value").innerHTML = "";
			document.querySelector("#discount-code-error").innerHTML = "";
			return;
		}

		if (price.length > 0) {
			console.log("working...");
		try {
			let emptyResponce = await fetch(window.Shopify.routes.root + 'cart.js');
			let emptyCartData = await emptyResponce.json();
			let hasOtherProduct;
				emptyCartData.items.forEach((emptyData) => {
					console.log(emptyData.product_type);
					if (emptyData.product_type != "POS") {
						hasOtherProduct = true;
					}else{
						hasOtherProduct = false;
					}
				});
				setTimeout(() => {
					if (hasOtherProduct == false) {
						emptyCartData.items.forEach(async (emptyData) => {
							try {
								await fetch('/cart/update.js', {
									method: 'post',
									headers: {
										Accept: "application/json",
										"Content-Type": "application/json"
									},
									body: JSON.stringify({
										updates: {
											[emptyData.key]: 0
										}
									})
								});
								this.updateCart();
							} catch (error) {
								console.log("Empty cart function removing error: " + error);
								
							}
						});
					}
				}, 100);
			
		} catch (error) {
			console.log("Empty cart function error: " + error);
			
		}
	}
	}
}
customElements.define("wi-cartdrawer", WIcartDrawer);




